import * as React from 'react';
import { ISelectProps } from '../Select';
import { ISelectFocusOptionActions, TOptionValue } from '../types';

interface IFocusOptionControllerProps extends ISelectProps<TOptionValue | TOptionValue[]> {
  open: boolean;
}

interface IFocusOptionControllerData {
  focusedIndex: number;
  actions: ISelectFocusOptionActions;
}

export function useFocusOptionController(props: IFocusOptionControllerProps): IFocusOptionControllerData {
  const [focusedIndex, setFocusedIndex] = React.useState(-1);

  React.useEffect(() => {
    const { options, value } = props;

    const selectedIndex = Array.isArray(value)
      ? options.findIndex(option => value.includes(option.value))
      : options.findIndex(option => value === option.value);
    setFocusedIndex(Math.max(selectedIndex, 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  const moveFocus = (delta: -1 | 1) => {
    const { options } = props;

    let nextIndex = focusedIndex + delta;
    let nextOption = options[nextIndex];

    while (nextOption && (nextOption.isTitle || nextOption.disabled)) {
      nextIndex += delta;
      nextOption = options[nextIndex];
    }

    if (nextIndex < 0 || nextIndex >= options.length) {
      return;
    }

    setFocusedIndex(nextIndex);
  };

  return {
    focusedIndex,
    actions: {
      moveFocus,
      setFocusedIndex,
    },
  };
}
